import { ElementRef, Renderer2 } from '@angular/core';

import { hasValue, isTrue } from '../util';
import { FeatureGuide } from './feature-guide';
import { FeatureGuidePosition } from './feature-guide-position';
import { FeatureGuideTooltip } from './feature-guide-tooltip';
import { FeatureGuideTooltipService } from './feature-guide-tooltip.service';
import {
  getFeatureGuideActiveClass,
  getFeatureGuideId,
  getFeatureGuidePosition,
  getFeatureGuideTemplate,
  getFeatureGuideTitle,
  isPrimaryFeatureGuide
} from './util';

const DEFAULT_TITLE = 'what.is.new';
const DEFAULT_ACTIVE_CLASS = 'feature-guide-active';

export class FeatureGuideElement {

  private visible = false;

  get id() {
    return getFeatureGuideId(this.featureGuide);
  }

  get title() {
    return getFeatureGuideTitle(this.featureGuide) || DEFAULT_TITLE;
  }

  get template() {
    return getFeatureGuideTemplate(this.featureGuide);
  }

  get primary() {
    const primary = isPrimaryFeatureGuide(this.featureGuide);
    return hasValue(primary) ? primary : true;
  }

  get position() {
    return getFeatureGuidePosition(this.featureGuide) || FeatureGuidePosition.LEFT_TOP;
  }

  get activeClass() {
    return getFeatureGuideActiveClass(this.featureGuide) || DEFAULT_ACTIVE_CLASS;
  }

  constructor(private featureGuide: FeatureGuide,
    private hostElement: ElementRef,
    private renderer: Renderer2,
    private featureGuideTooltipService: FeatureGuideTooltipService
  ) {
  }

  getId() {
    return this.id;
  }

  isVisible() {
    return isTrue(this.visible);
  }

  show() {
    if (!this.isVisible()) {
      this.renderer.addClass(this.hostElement.nativeElement, this.activeClass);
      this.visible = true;
      if (this.primary) {
        this.featureGuideTooltipService.show(this.hostElement, this.featureGuideTooltip());
      }
    }
  }

  hide() {
    if (this.isVisible()) {
      this.renderer.removeClass(this.hostElement.nativeElement, this.activeClass);
      this.visible = false;
      if (this.primary) {
        this.featureGuideTooltipService.hide();
      }
    }
  }

  private featureGuideTooltip(): FeatureGuideTooltip {
    return {
      id: this.id,
      title: this.title,
      template: this.template,
      position: this.position
    };
  }
}
